import { IEletronicInventory } from "../models";

export const data: IEletronicInventory = {
  nameProduct: "",
  assetNumber: "",
  serialNumber: "",
  screen: "",
  description: "",
  manufacturer: "",
  model: "",
  processor: "",
  memoryRam: "",
  invoiceNumber: "",
  purchasePrice: "",
  datePurchase: "",
  physicalLocation: "Tegra",
  status: "Disponível",
  userId: 0,
  statementOfResponsibility: 0,
  observation: "",
  client: "",
  isDeleted: false,
  urlStatement: "",
};

// export const dataUpdate: IEletronicInventory = {
//   nameProduct: "Dell",
//   assetNumber: "1234",
//   serialNumber: "1234",
//   screen: "16.7 pol",
//   description: "full HD",
//   manufacturer: "DELL",
//   model: "Vostro",
//   processor: "i5 8th",
//   memoryRam: "8GB",
//   invoiceNumber: "123",
//   purchasePrice: "4000",
//   datePurchase: "2021-11-21",
//   physicalLocation: "Home Office",
//   status: "Alocado",
//   userId: 1,
//   statementOfResponsibility: 0,
//   observation: "",
//   client: "",
//   isDeleted: false,
// };

export const listStateOfResponsibility = [
  { id: 1, name: "Sim" },
  { id: 2, name: "Não" },
];

export const listStatus = [{ name: "Disponível" }, { name: "Alocado" }, { name: "Em manutenção" }, { name: "Vendido" }, { name: "Doado" }];

export const listPhysicalLocation = [{ name: "Tegra" }, { name: "Home Office" }];
